import { render, staticRenderFns } from "./copySet.vue?vue&type=template&id=cb612904&"
import script from "./copySet.vue?vue&type=script&lang=js&"
export * from "./copySet.vue?vue&type=script&lang=js&"
import style0 from "./copySet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copySet.vue"
export default component.exports